export const siteMetadata = {
  name: 'Pleasant Playground Community Garden',
  shortName: 'Pleasant Garden',
  primaryDomain: 'https://pleasantplaygroundgarden.com',
  alternateDomain: 'https://pleasantplaygroundgarden.org',
  description:
    'Pleasant Playground Community Garden is a neighborhood garden at 6757 Chew Avenue in Philadelphia, Pennsylvania, where neighbors grow food, learn organic gardening, and build community.',
  imagePath: '/wide-garden-path-with-raised-beds-thumb.jpg',
  imageWidth: 720,
  imageHeight: 542,
  address: {
    streetAddress: '6757 Chew Avenue',
    addressLocality: 'Philadelphia',
    addressRegion: 'PA',
    postalCode: '19119',
    addressCountry: 'US',
  },
  geo: {
    latitude: 40.057611,
    longitude: -75.181389,
  },
  email: 'pleasantplaygroundgarden@gmail.com',
  socialProfiles: [
    'https://www.instagram.com/pleasantgarden/',
    'https://www.facebook.com/pleasantgarden215/',
  ],
};

export const pageMetadata = {
  '/': {
    title: 'Pleasant Playground Community Garden | Philadelphia, PA',
    description:
      'Visit Pleasant Playground Community Garden at 6757 Chew Avenue in Philadelphia. Learn about garden plots, volunteer days, events, and community food-growing programs.',
  },
  '/about': {
    title: 'About Pleasant Playground Community Garden | Mount Airy Philadelphia',
    description:
      'Learn the story of Pleasant Playground Community Garden, a Mount Airy green space where neighbors grow fresh food, teach organic gardening, and build community.',
  },
  '/events': {
    title: 'Garden Events & Volunteer Days | Pleasant Playground Community Garden',
    description:
      'See upcoming and past Pleasant Playground Community Garden events, volunteer days, work parties, and neighborhood gatherings in Philadelphia.',
  },
  '/contact': {
    title: 'Contact Pleasant Playground Community Garden | 6757 Chew Avenue',
    description:
      'Contact Pleasant Playground Community Garden for questions about membership, volunteering, garden updates, and finding the garden at 6757 Chew Avenue in Philadelphia.',
  },
  '/apply': {
    title: 'Join the Garden | Pleasant Playground Community Garden Waitlist',
    description:
      'Apply to join Pleasant Playground Community Garden or connect with the garden about available plots, the waitlist, and the 2026 growing season.',
  },
};

export function getSiteUrl() {
  return (process.env.REACT_APP_SITE_URL || siteMetadata.primaryDomain).replace(/\/$/, '');
}

export function getCanonicalUrl(pathname = '/') {
  const siteUrl = getSiteUrl();
  const normalizedPath = pathname === '/' ? '/' : `/${pathname.replace(/^\/+|\/+$/g, '')}`;
  return `${siteUrl}${normalizedPath}`;
}

export function getSocialImageUrl() {
  return `${getSiteUrl()}${siteMetadata.imagePath}`;
}
